export const general: GeneralSetup = {
    canonicalUrl: 'https://kromatic.com/tools/experiment-calculator',
    documentDescription:
        'Easily determine the ideal sample size and margin of error for your research or experiments with our versatile Experiment Calculator. Whether you have two variations or more, obtain precise recommendations for confident decision-making.',
    documentTitle: 'Experiment Calculator - Kromatic',
    favicon: '/favicon.png',
    faq: [
        {
            question: 'What does the Experiment Calculator do?',
            answer:
                'The Experiment Calculator helps you estimate a recommended sample size and analyze binary A/B test outcomes so you can make more confident decisions.',
        },
        {
            question: 'What is population size in this calculator?',
            answer:
                'Population size is the full group you want to learn about. Your sample is a smaller subset from that population used to estimate the broader result.',
        },
        {
            question: 'How should I choose confidence level?',
            answer:
                'Confidence level controls how certain you want to be that results fall within the margin of error. If you are unsure, use the default 95%.',
        },
        {
            question: 'What does target margin of error mean?',
            answer:
                'Target margin of error is the amount of uncertainty you can tolerate in your estimate. Smaller margins require larger sample sizes.',
        },
        {
            question: 'When should I use range of expected results?',
            answer:
                'If you have a realistic minimum and maximum expected outcome, adding that range can reduce required sample size while still meeting your confidence target.',
        },
        {
            question: 'What result types are supported?',
            answer:
                'This tool is built for binary outcomes such as yes or no conversions. It is not intended for averaging non-binary scales directly.',
        },
        {
            question: 'How does threshold affect analysis?',
            answer:
                'Threshold is the benchmark your variation must beat. If no fixed benchmark exists, you can leave threshold empty and compare variants directly.',
        },
        {
            question: 'What is margin of error in analysis?',
            answer:
                'Margin of error represents the uncertainty around observed results and indicates a plausible range for the true population value.',
        },
        {
            question: 'Can I compare more than two variants?',
            answer:
                'Yes. You can add multiple variants and compare them in the analysis step to evaluate relative performance.',
        },
        {
            question: 'What should I do if the result is inconclusive?',
            answer:
                'Inconclusive outcomes usually mean there is not enough evidence yet. Collecting more sample size can improve confidence in the comparison.',
        },
    ],
    portionMarking: null,
    siteName: 'Kromatic',
    socialDescription:
        'Estimate sample size, margin of error, and compare binary A/B test outcomes with Kromatic’s Experiment Calculator.',
    socialImage: 'https://kromatic.com/tools/experiment-calculator/assets/images/krobar-share.png',
    socialImageAlt: 'Experiment Calculator preview image from Kromatic',
    socialTitle: 'Experiment Calculator | Kromatic',
};
